import React, { PureComponent, Fragment } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { validateName, validateSurname, validateEmail } from '../../../helpers/formHelper';
import ButtonSpinner from '../../shared/UI/button-spinner';
import { connect } from 'react-redux';
import ResponsiveImage from '../../shared/responsiveImage';
import { withApollo } from 'react-apollo';
import { AddPassenger } from '../../../actions/passenger';
import CustomInputText from '../../shared/form/CustomInputText';
import { itemProducts } from '../../../helpers/itemsHelper';
import cookie from "js-cookie";
import { GetCountries } from '../../../actions/nationality';
import { bindActionCreators } from 'redux';
import { SetSignUpPaxForm } from '../../../actions/form';
import { POPULAR_COUNTRIES } from '../../../config';

class SavePaxModal extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            termChecked:false,
            dialCode:""
        }
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleDialCodeChange = this.handleDialCodeChange.bind(this);
    }

    componentDidMount(){
        const { client, nationality } = this.props;
        if(nationality.length === 0) GetCountries(client);
    }

    handleDialCodeChange(e, setFieldValue, setFieldTouched){
        setFieldValue("telephone_country_code", e.target.value);
        setFieldTouched("telephone_country_code", true);
        this.setState({dialCode: e.target.value});
    }

    handleCheckboxChange(){
        this.setState({termChecked:!this.state.termChecked});
    }

    onSubmitHandler(values, formikBag){

        const token = cookie.get("ap.token");
        const { client, currentBooking: { uuid }, paxNumber, SetSignUpPaxForm, nationality } = this.props;
        let dialCode, phoneData = "";

        if(values.telephone_country_code !== ""){
            dialCode = nationality.filter(item => item.iso_country_code === values.telephone_country_code)[0].dialing_code;
            phoneData = `${values.telephone_country_code}-${dialCode}-${values.phone}`
        }
    

        const payload = {
            ...values,
            agree:this.state.termChecked,
            phone_data: phoneData
        } 
        
        formikBag.setSubmitting(true);	      

        SetSignUpPaxForm(payload);

        AddPassenger(client, uuid, paxNumber, payload).then(response => {
            if(response.data.addPassenger !== ""){
                formikBag.setSubmitting(false);
                window.location.href = `${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${uuid}&t=${token}`;
            }    
        });

    }

    render(){
        
        const { termChecked } = this.state;
        const { currentBooking: { itinerary, items }, paxNumber, nationality } = this.props;
        const _itinerary = itinerary !== undefined ? itinerary : [];
        const _startLocation = _itinerary.length > 0 ? _itinerary[0].to : "";
        const _endLocation = _itinerary.length > 0 ? _itinerary[_itinerary.length - 1].to : "";
        const _image = _itinerary.length > 0 ? _itinerary[0].cityInfo.hero[0] : "";
        const _numDay = items !== undefined ? (items[0].nights + 1) : "";
        const _itemProducts = itemProducts(items);
        const _nationality = nationality !== undefined ? nationality : [];
        const _popularCountries = _nationality.filter(item => { return POPULAR_COUNTRIES.includes(item.name) });


    
        return (
            <Fragment>
                <div className="clearfix">
                    <div className="col col-12 px2 margin-b-30">
                        <h2 className="save-pax-heading margin-b-10 black-text">Add Passenger &amp; Save progress</h2>
                        <p className="black-text"> {_numDay} days trip from {_startLocation} to {_endLocation}  </p>
                            {
                                _itemProducts.map((item, index)=>{
                                    return (
                                    <p key={index} className="black-text">
                                        <svg width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"></path></svg>
                                        <span className="viking-text bold">{ item.name} ({item.nights + 1} days)</span>
                                    </p>
                                    )
                                })
                            }

                       
                    </div>
                </div>

                <div className="clearfix">
            
                    <div className="col col-12 md-col-5 lg-col-6 margin-b-30 px2 xs-hide sm-hide">
                        <div className="trust-build round-corners">
                            <div className="clearfix">
                                <div className="col col-12">
                                    <ResponsiveImage width={444} widthRetina={444} src={_image} alt={""} quality={70} />
                                </div>
                                <div className="col col-12">
                                    <div className="benefit-container">
                                        <p className="benefits-text black-text">Benefit of booking with Busabout</p>
                                        <ul>
                                            <li>When you book one of our trips you are absolutely guaranteed to go</li>
                                            <li>Discount for groups, past passengers and multi-trip</li>
                                            <li>Flexible deposit and instance booking confirmation</li>
                                            <li>Our awesome crew are there to help you make the most of every day and every experience</li>
                                            <li>Secure online booking and management</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col col-12 md-col-7 lg-col-6 margin-b-30 px2">

                        <div className="save-pax-box round-corners black-text">
                            <p className="bold uppercase margin-b-20">Sign up and hold this trip</p>
                            <p className="f-size-14 margin-b-40">Before you can continue please enter your details to   <span className="bold">save the progress of this itinerary</span> to guarantee a place when you need to book.</p>

                              <Formik
                                initialValues={{
                                    name:"", 
                                    surname:"", 
                                    email:"",
                                    telephone_country_code:"",
                                    phone:""
                                }}
                                onSubmit={(values, formikBag) => this.onSubmitHandler(values, formikBag)}
                            >    
                            {({isSubmitting, errors, touched, setFieldValue, setFieldTouched}) => (  
                                    <Form className="form round-corners" noValidate>
                     
                                        <Field validate={validateName} name="name" component={CustomInputText} type="text" placeHolderText="First Name*" isRequired={true} />     
                                        <ErrorMessage name="name" component="div" className="error-text"/> 

                                        <Field validate={validateSurname} name="surname" component={CustomInputText} type="text" placeHolderText="Surname*" isRequired={true} /> 
                                        <ErrorMessage name="surname" component="div" className="error-text"/> 

                                        <Field validate={validateEmail} name="email" component={CustomInputText} type="text" placeHolderText="Email address*" isRequired={true} /> 
                                        <ErrorMessage name="email" component="div" className="error-text"/> 

                                        <div className="clearfix pb2">
                                            <div className="col col-6">
                                                <Field
                                                    component="select" 
                                                    name="telephone_country_code"
                                                    value={this.state.dialCode} 
                                                    onChange={(e) => this.handleDialCodeChange(e, setFieldValue, setFieldTouched) }
                                                    className={`busabout-selectdropdown small outline border-t-l border-b-l no-border-right ${touched.telephone_country_code && errors.telephone_country_code ? 'error' : ''} ${this.state.dialCode !== '' ? 'active' : ''}`}> 
                                                    
                                                    <optgroup>
                                                    <option value="" disabled>Dial code</option> 
                                                        {
                                                            _popularCountries.map(data => (<option value={data.iso_country_code} key={`dialcode${data.iso_country_code_3}`}> {data.name} ({data.dialing_code})</option>))
                                                        }
                                                    </optgroup>
                                                    <optgroup>
                                                        {
                                                            _nationality.map(data => (<option value={data.iso_country_code} key={`dialcode${data.iso_country_code_3}`}> {data.name} ({data.dialing_code})</option>))
                                                        }
                                                    </optgroup>
                                                    </Field>
                                                    { (touched.telephone_country_code && errors.telephone_country_code) && <div className="error-text pt1">Dial code required</div> }
                                            </div>
                                            <div className="col col-6">
                                                <Field name="phone" component={CustomInputText} type="number" placeHolderText="Telephone" isRequired={true} clazz={''} />
                                            </div>
                                        </div>

                                
                                        <div className="margin-t-10 margin-b-30">
                                            <label className={`checkbox-container ${termChecked ? 'active' : ''}`}>   
                                                <input name="checkbox1" type="checkbox" onChange={this.handleCheckboxChange}/>
                                                <span className="checkmark"></span>
                                                <span className="regular f-size-14">Keep me informed about the progress of my booking. We take the protection of your personal data seriously. </span>
                                            </label>
                                        </div>


                                        <button type="submit" className="busabout--cta orange rounded-corner" disabled={!isSubmitting && paxNumber === 0}>
                                            { !isSubmitting && <Fragment>Continue</Fragment> }
                                            { isSubmitting &&  <ButtonSpinner clazz={"white"} /> }
                                        </button>
                                    </Form>
                            )}
                            </Formik>
                        </div>


                    </div>
                 
               </div>
            </Fragment>
        )
    }
}


const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        paxNumber:state.currentBooking.passengers.length,
        nationality:state.nationality
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        SetSignUpPaxForm
    }, dispatch);
  }

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(SavePaxModal));
